import React from 'react';
import FlagTheme from './imgs/flag-theme.svg';
import FlagGroupFree from './imgs/flag-groupfree.svg';
import FlagInbound from './imgs/flag-inbound.svg';
import FlagOutbound from './imgs/flag-outbound.svg';
import FlagSignature from './imgs/flag-signature.svg';
import styles from './style.module.scss';
import { I_Tag } from '@Redux/detail/Group/interfaces';

export interface I_Props {
    ProductType?: string; // 1:主題旅遊 2:國外團體 3:台灣團體 4:團體自由行(不分國內外)
    TagList?: I_Tag[];
}

interface I_FlagData {
    [key: string]: { src: string; alt: string };
}

const flagData: I_FlagData = {
    '1': { src: FlagTheme, alt: '主題旅遊' },
    '2': { src: FlagOutbound, alt: '國外團體' },
    '3': { src: FlagInbound, alt: '台灣團體' },
    '4': { src: FlagGroupFree, alt: '團體自由行' },
};

const tagData: I_FlagData = {
    '191': { src: FlagSignature, alt: '璽品旅遊' },
}

const Flag: React.FC<I_Props> = ({ ProductType = '1', TagList }) => {
    const selectedTag = TagList?.find((tag) => Object.keys(tagData).includes(tag.TagNo.toString()));
    const selectedFlag = selectedTag ? tagData[selectedTag.TagNo] : flagData[ProductType];

    return selectedFlag ? (
        <img src={selectedFlag.src} className={styles.flag} alt={selectedFlag.alt} />
    ) : null
};

export default Flag;
